var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGiftBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 468,
    height: 562,
    viewBox: "0 0 468 562",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_219)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M468 241.624H27V324.526H468V241.624Z",
    fill: "#E0EC4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.694 241.624H199.918V324.526H294.694V241.624Z",
    fill: "#FDF9F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.929 324.914H66.0713V562H428.929V324.914Z",
    fill: "#E0EC4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.694 357.843H199.918V562H294.694V357.843Z",
    fill: "#FDF9F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.0713 364.816H199.919V324.914H295.082V364.816H428.929V324.914H66.0713V364.816Z",
    fill: "#7EC25E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.694 324.914H199.918V364.816H294.694V324.914Z",
    fill: "#F1DDCA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M247.5 241.624C236.669 192.037 215.392 137.802 181.737 144.775C153.884 150.586 141.119 197.073 148.855 242.011H247.5V241.624Z",
    fill: "#FDF9F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.413 223.029C218.873 189.325 207.655 165.307 191.021 156.009C163.942 141.288 149.629 207.92 232.413 223.029Z",
    fill: "#F1DDCA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M246.727 241.624C257.558 192.037 279.221 137.414 312.49 144.387C340.342 150.198 353.108 196.686 345.371 241.624H246.727Z",
    fill: "#FDF9F4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M261.813 223.029C275.353 189.325 286.571 165.307 303.206 156.009C330.285 141.288 344.598 207.92 261.813 223.029Z",
    fill: "#F1DDCA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.2149 17.694L74.5763 36.4698C76.0887 37.9839 77.3017 38.5903 79.1292 37.9877L105.911 33.1821C110.779 32.5833 113.19 36.8206 111.646 41.3553L99.3569 65.5354C98.7425 66.7444 98.4274 68.8611 99.026 70.6766L111.975 94.5859C114.386 98.8231 110.715 103.053 106.461 102.442L78.8129 98.4761C76.6861 98.171 74.8586 98.7736 74.2442 99.9826L55.2916 119.315C52.2352 122.336 46.7686 121.119 46.1858 116.279L42.3739 89.3571C41.7752 87.5417 41.1766 85.7263 39.0498 85.4212L14.7888 73.2931C11.1496 71.4738 11.1812 65.425 14.5369 63.3121L38.9245 51.2449C40.752 50.6423 41.3664 49.4333 41.6815 47.3166L46.0775 20.707C46.7077 16.4736 52.1902 14.6658 55.2149 17.694Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M376.862 93.06L393.36 80.1746C394.686 79.1731 395.281 78.3051 395.013 76.8358L394.172 55.7322C394.23 51.9256 397.745 50.524 401.067 52.1943L418.348 64.2189C419.212 64.8202 420.806 65.288 422.266 65.0212L442.028 57.6126C445.543 56.2109 448.404 59.4839 447.481 62.6893L441.486 83.5242C441.024 85.1269 441.293 86.5962 442.157 87.1974L455.002 103.829C456.998 106.501 455.481 110.574 451.697 110.507L430.592 110.569C429.132 110.836 427.673 111.102 427.212 112.705L415.302 130.066C413.515 132.67 408.868 132.001 407.601 129.196L400.922 109.16C400.653 107.691 399.789 107.089 398.195 106.622L378.205 100.406C375.017 99.4708 374.211 95.0629 376.862 93.06Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 441,
    height: 418,
    fill: "white",
    transform: "translate(27 144)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftBox);
export default __webpack_public_path__ + "static/media/giftBox.0ca132e0493f8bf76e6cb78deebeaa3d.svg";
export { ForwardRef as ReactComponent };